import api from '@/api';

const resource = 'ei/aluno';

export default {
  getContatoAluno( dados ) {
    return api.get( `${resource}/contatoAluno`, { params: dados} );
  },
};
